import React from 'react';

const Footer = () => (
  <footer className="footer">
    <hr />
    <p>
      © {new Date().getFullYear()} Krishnendu Ghosh. All rights reserved.
    </p>
  </footer>
);

export default Footer;